import { useSelector } from 'react-redux'
import { IUser } from '../../../../../shared/src/sharedTypes'
import { State } from '../../../redux/store'

export default () => useSelector<State, IUser>((state) => state.user)
